import React, { Component } from "react";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import SupportWidget from "../components/common/SupportWidget";

import ChromeRecommendation from "../components/common/ChromeRecommendation";
import ReduxToastr, { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import moment from "moment";
import * as actions from "../actions";
import EkoVideo from "../components/elements//EkoVideo";
import Api, { ROOT_URL, setHeaders } from "../util/Api";
import PromotionModal from "../screens/Promotion/PromotionModal";
import EmailModal from "../components/forms//EmailModal";
import PromotionPhoneModal from "../screens/Promotion/PromotionPhoneModal";
import { FETCH_VIDEO_CONFIGS, FETCH_VIDEO_DATAS } from "../actions/types";
import EkoFormButton from "../components/elements//form/EkoFormButton";
import TooltipService from "../services/TooltipService";
import { Fab, Action } from "react-tiny-fab";
import "react-tiny-fab/dist/styles.css";
import { withRouter } from "react-router";
import Document from "../components/forms/Document";
import axios from "axios";

const documentLinks = [
  "/dashboard/salesInvoice/add/toCustomer",
  "/dashboard/salesInvoice/edit/",
  "dashboard/salesInvoice/add/toSupplier",
  "dashboard/salesInvoice/proforma/add",
  "dashboard/purchases/purchaseInvoice/add/productServiceInvoice",
  "dashboard/purchases/purchaseInvoice/edit/",
  "dashboard/purchases/purchaseInvoice/insert/",
  "dashboard/purchases/purchaseInvoice/add/expenseInvoice",
  "dashboard/purchases/purchaseInvoice/add/customerReturnInvoice",
  "dashboard/purchases/receipt/add",
  "dashboard/purchases/receipt/edit",
  "dashboard/purchases/otherReceipt/add",
  "dashboard/purchases/otherReceipt/edit",
  "dashboard/purchases/insurancePolicy/add",
  "dashboard/purchases/insurancePolicy/edit",
  "dashboard/salesInvoice/proforma/add",
  "dashboard/salesInvoice/proforma/edit",
  "dashboard/salesInvoice/otherSales/add",
  "dashboard/salesInvoice/otherSales/edit",
  "dashboard/salesInvoice/zreports/add",
  "dashboard/salesInvoice/zreports/edit",
  "dashboard/salesInvoice/soleprofv2/add",
  "dashboard/salesInvoice/soleprofv2/edit",
  "dashboard/fixedAsset/add",
  "dashboard/fixedAsset/edit",
];

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      sending: false,
      showEmailModal: false,
      showPhoneModal: false,
      showSupportWidget: false,
      invitationSmmData: [],
      invitationSmmExists: false,
      contactPanelOpen: false,
      contactName: "",
      contactEmail: "",
      contactMessage: "",
      contactFiles: [],
      contactSubmitting: false
    };
  }

  openContactPanel = () => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    this.setState({
      contactPanelOpen: true,
      contactName: user.firstname && user.lastname ? `${user.firstname} ${user.lastname}` : "",
      contactEmail: user.email || "",
      contactMessage: "",
      contactFiles: [],
      contactSubmitting: false
    });
  };

  closeContactPanel = () => {
    this.setState({ contactPanelOpen: false });
  };

  handleContactFileChange = (e) => {
    const all = Array.from(e.target.files || []);
    const images = all.filter((f) => f && f.type && f.type.startsWith("image/"));
    if (all.length !== images.length) {
      toastr.warning("Uyarı", "Sadece resim dosyaları eklenebilir.");
    }
    if (images.length > 5) {
      toastr.warning("Uyarı", "En fazla 5 resim ekleyebilirsiniz.");
      this.setState({ contactFiles: images.slice(0, 5) });
    } else {
      this.setState({ contactFiles: images });
    }
  };

  removeContactFile = (index) => {
    this.setState((prev) => ({
      contactFiles: prev.contactFiles.filter((_, i) => i !== index)
    }));
  };

  submitContactForm = () => {
    const { contactName, contactEmail, contactMessage, contactFiles } = this.state;
    if (!contactEmail) {
      toastr.error("Hata", "Lütfen e-posta adresinizi giriniz.");
      return;
    }
    if (!contactMessage || contactMessage.trim().length === 0) {
      toastr.error("Hata", "Lütfen mesajınızı giriniz.");
      return;
    }
    const invalidFiles = contactFiles.filter((f) => !f || !f.type || !f.type.startsWith("image/"));
    if (invalidFiles.length > 0) {
      toastr.error("Hata", "Sadece resim dosyaları gönderebilirsiniz.");
      return;
    }
    const formData = new FormData();
    formData.append("name", contactName || "");
    formData.append("email", contactEmail);
    formData.append("message", contactMessage);
    contactFiles.forEach((file, idx) => {
      formData.append(`files[${idx}]`, file);
    });
    this.setState({ contactSubmitting: true });
    setHeaders();
    axios.post(ROOT_URL + "/company/supportWidget", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => {
      this.setState({ contactSubmitting: false });
      if (response && response.data && (response.data.status === "ok" || response.data.success)) {
        toastr.success("Başarılı", "Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapılacaktır.");
        this.closeContactPanel();
      } else {
        toastr.error("Hata", response && response.data && response.data.message ? response.data.message : "Mesaj gönderilirken bir hata oluştu.");
      }
    }).catch((error) => {
      this.setState({ contactSubmitting: false });
      toastr.error("Hata", error && error.response && error.response.data && error.response.data.message ? error.response.data.message : "Mesaj gönderilirken bir hata oluştu.");
    });
  };
  checkInvitationSmm() {
    var _self = this;
    Api.get("/check-invitation-smmm", (response, err) => {
      if (response.status == "ok" && response.isExist == 1) {
        _self.setState({invitationSmmExists: true, invitationSmmData: response.result});
      }
    });
  }
  acceptSMMInvitation(invitation_id) {
    var _self = this;
    Api.post("/accept-invitation-smmm", {iid: invitation_id}, (response, err) => {
      if (err != false) {
        toastr.error("Hata!", "Sistemsel Bir Sorun Oluştu");
      } else if (response.result !== false) {
        toastr.success("Başarılı", "Davet başarıyla kabul edildi. Sağ üst bölümden işletme değişimi yapabilirsiniz.");
        document.getElementById("smmInvitationDiv").remove();
        window.location.reload(false);
      } else if (response.result !== true) {
        toastr.error("Hata", "Eşleştirme ve izin sırasında hata oluştu. Lütfen tekrar deneyiniz.");
      }
      this.setState({saving: false});
    });
  }
  componentWillMount() {
    this.checkInvitationSmm(); // check for waiting smmm invitation on load
    this.props.fetchCachedDataAsKey(
        "/getVideoDatas",
        FETCH_VIDEO_DATAS,
        "videos",
        "3:day"
    );
    this.props.updateFetchedData(
        FETCH_VIDEO_CONFIGS,
        JSON.parse(localStorage.getItem("videos_config"))
    );
    localStorage.setItem("lastActivity", moment().toISOString());
    if (localStorage.getItem("user")) {
      const user = JSON.parse(localStorage.getItem("user"));
      let name = null;
      if (user.firstname !== null && user.lastname !== null)
        name = `${user.firstname} ${user.lastname}`;
      window.setDesk(name, user.email);
    }
  }

  // promosyon kodu popup kontrolü
  componentDidMount() {
    TooltipService.fetchLabels();
    if (localStorage.getItem("user")) {
      const user = JSON.parse(localStorage.getItem("user"));
      if (
          user.shouldShowPromotionPopup &&
          user.shouldShowPromotionPopup === true
      ) {
        user.shouldShowPromotionPopup = false;
        localStorage.setItem("user", JSON.stringify(user));
        this.showPhoneConfirm();
      }
    }
  }

  openModal() {
    const self = this;
    Api.post("/campaignIsThere", {}, (response, err) => {
      if (err) {
        toastr.error("Hata", err.message);
      } else self.setState({ showModal: true });
    });
  }

  openEmailModal = () => {
    this.setState({ showEmailModal: true });
  };

  forceRefresh = () => {
    this.forceUpdate();
  };

  showPhoneConfirm = () => {
    let user = JSON.parse(localStorage.getItem("user"));

    if (user.is_free === 1) {
      toastr.error(
          "Ücretsiz Paket ile Sadece Mobil Uygulamamızı Kullanabilirsiniz"
      );
    }

    this.setState({ showPhoneModal: true });
  };

  resendMail = () => {
    this.setState({ sending: true }, () => {
      Api.get("/user/send-activation", (response, err) => {
        this.setState({
          sending: false,
        });

        if (err) {
          toastr.error("Hata", err.message);
        } else {
          toastr.success("Başarılı!", response.message);
        }
      });
    });
  };

  closePhoneModal = () => {
    this.setState({ showPhoneModal: false });
  };

  render() {
    const pathname = this.props.location?.pathname
    const isDocument = documentLinks.find(d => pathname.includes(d)) && this.props.addDocument?.uri;
    const user = JSON.parse(localStorage.getItem("user"));
    //console.log('isDocument', isDocument, this.props.addDocument, pathname);
    // if page is dashboard add full-width class to page-wrapper
    const full_width = "full-width";
    //const full_width = window.location.pathname === "/dashboard" ? "" : "full-width";

    return (
        <div className={`page-wrapper ${full_width}`} lang="tr">
          <ChromeRecommendation />
          {user && parseInt(user.is_activated, 10) !== 1 ? (
              <div
                  className="alert alert-warning"
                  style={{ textAlign: "center", marginBottom: 0, padding: 8 }}
                  role="alert"
              >
                <div style={{ color: "#333", display: "inline-block" }}>
                  {user.email} adresinize göndermiş olduğumuz maildeki aktivasyon
                  linkine tıklayarak hesabınızı aktive ediniz!{" "}
                  <EkoFormButton
                      className={"btn btn-activation"}
                      isLoading={this.state.sending}
                      onClick={this.resendMail}
                      label={"Tekrar Gönder"}
                  />
                  <EkoFormButton
                      className={"btn btn-activation"}
                      onClick={this.openEmailModal}
                      label={"E-posta Değiştir"}
                  />
                </div>
              </div>
          ) : null}


          {parseInt(user.is_activated, 10) == 1 && user.expiryDays<15 ? (
              <div
                  className="alert alert-warning"
                  style={{ textAlign: "center", marginBottom: 0, padding: 8 }}
                  role="alert"
              >
                <div style={{ fontSize: 16, color: "#333", display: "inline-block" }}>
                  Üyeliğinizin bitmesine <label style={{fontWeight: "bold"}}>{user.expiryDays}</label> gün kalmıştır.
                  <EkoFormButton
                      className={"btn btn-activation"}
                      style={{marginLeft: 15 }}
                      isLoading={this.state.sending}
                      onClick={event =>  window.location.href='/subscriber'}
                      label={"Süreyi Uzat"}
                  />
                </div>
              </div>
          ) : null}


          <SupportWidget
              show={this.state.showSupportWidget}
              handleClose={() => this.setState({ showSupportWidget: false })}
          />
          <Header
              visibleMenu={this.props.visibleMenu}
              path={window.location.pathname}
          />
          <div className="page-wrapper-row full-height">
            <div className="page-wrapper-middle">
              <div className="page-container">
                {/*<BrowserUpdate path={location.pathname}/>*/}
                <div className="page-content-wrapper">
                  <div className="page-content" style={isDocument ? {display: "flex"} : {}}>
                    {isDocument && <Document /> || null}
                    <div className="container">
                      {this.state.invitationSmmExists && (<>

                        {
                          // for each invitationSmmData
                          this.state.invitationSmmData.map((invitationSmmData, index) => {
                            return (
                                <div className="row">
                                  <div className="col-md-6 col-xs-12 col-md-offset-3">
                                    <div className="alert alert-info text-center" id="smmInvitationDiv"><strong>
                                      {invitationSmmData.company_first_name} {invitationSmmData.company_last_name}</strong>
                                      hesabını yönetmeniz için davet gönderdi.
                                      <button type="button" className="btn btn-info btn-sm" onClick={this.acceptSMMInvitation.bind(this, invitationSmmData.id)}>KABUL ET</button></div>
                                  </div>
                                </div>
                            )
                          })
                        }

                      </>)}
                      <EkoVideo path={window.location.pathname} />
                      {this.props.children}
                      {this.props.authenticated && (
                          <>
                            <div onClick={this.openContactPanel} style={{
                              "cursor":"pointer",
                              "position":"fixed",
                              "top":"74%",
                              "right":"-30px",
                              "transform":"translateY(-50%) rotate(-90deg)",
                              "backgroundColor":"#4a87bf",
                              "color":"#fff",
                              "padding":"7px",
                              "borderTopLeftRadius":"4px",
                              "borderTopRightRadius":"4px",
                              "zIndex":"9998"
                            }}>Bize Ulaşın</div>
                          </>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {this.props.subscribeDesc ? (
                  <div className="campaign-faq" style={{ width: "100%" }}>
                    <div className="container">
                      <br />
                      <br />
                      <div className="col-md-4 col-sm-6">
                        <i className="fa fa-question-circle" aria-hidden="true" />
                      </div>
                      <h3>Banka havalesi ile ödeme yapabilir miyim?</h3>
                      <p>
                        Banka havalesi ile ödeme yapmak ister iseniz, kullanmak
                        istediğiniz paketin{" "}
                        <span style={{ fontWeight: "bold" }}>
                      minimum 12 aylık bedelini
                    </span>{" "}
                        havale edip bize e-posta atmanız yeterlidir. E-posta’da
                        hangi paketi kullanmak istediğinizi lütfen belirtiniz. Hesap
                        bilgilerimiz: ALICI: EkoHesap Bilgi Teknolojileri A.Ş.
                        BANKA: Türkiye İş Bankası A.Ş. IBAN: TR29 0006 4000 0011
                        3770 0924 73 AÇIKLAMA: Abonelik Ücreti Banka dekontu ile
                        birlikte aboneliğinizin başlatılmasını istediğiniz hesabın
                        e-posta adresini ve fatura bilgilerinizi
                        <span style={{ fontWeight: "bold" }}>
                      {" "}
                          iletisim@ekohesap.com
                    </span>{" "}
                        adresine gönderin.
                      </p>
                      <h3>Aboneliğimi nasıl iptal edebilirim?</h3>
                      <p>
                        Aboneliğiniz başladıktan sonra istediğiniz zaman bize
                        ulaşarak aboneliğinizi iptal edebilirsiniz. İptali
                        gerçekleştirdiğinizde paketinizin bir sonraki abonelik
                        yenileme dönemi için ücretlendirmesi yapılmaz. Geçmiş
                        dönemler için ücret iadesi bulunmamaktadır.
                      </p>
                      <h3>
                        Aboneliğimi iptal edersem, verilerimi dışarı aktarabilir
                        miyim?
                      </h3>
                      <p>
                        Tabi ki. Uygulamaya girdiğiniz tüm veriler size aittir.
                        Aboneliğinizi iptal etme işlemi esnasında verilerinizi dışa
                        aktarmak istediğinizi destek ekibimize lütfen iletin.
                      </p>
                      <h3>Promosyon kodumu nasıl kullanabilirim?</h3>
                      <p>
                        Promosyon kodunuzu girerek size özel avantajlardan
                        faydalanabilirsiniz.
                        <a onClick={this.openModal.bind(this)}>
                          Promosyon kodunuzu girmek için tıklayın.
                        </a>
                      </p>
                    </div>
                    <PromotionModal
                        showModal={this.state.showModal}
                        closeModal={() => {
                          this.setState({ showModal: false });
                        }}
                    />
                  </div>
              ) : (
                  ""
              )}
              <PromotionPhoneModal
                  showModal={this.state.showPhoneModal}
                  closeModal={this.closePhoneModal}
              />
              <EmailModal
                  showModal={this.state.showEmailModal}
                  forceRefresh={this.forceRefresh}
                  closeModal={() => {
                    this.setState({ showEmailModal: false });
                  }}
              />
            </div>
          </div>
          <ReduxToastr
              timeOut={5000}
              newestOnTop={false}
              preventDuplicates
              position="top-right"
              transitionIn="fadeIn"
              transitionOut="fadeOut"
              progressBar
          />
          {this.state.contactPanelOpen && (
            <>
              <div onClick={this.closeContactPanel} style={{
                position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: "rgba(0,0,0,0.4)", zIndex: 9998
              }} />
              <div style={{
                position: "fixed", top: 0, right: 0, bottom: 0,
                width: 440, maxWidth: "100%", backgroundColor: "#fff",
                zIndex: 9999, boxShadow: "-4px 0 20px rgba(0,0,0,0.15)",
                display: "flex", flexDirection: "column",
                transform: "translateX(0)", transition: "transform 0.3s ease"
              }}>
                <div style={{
                  backgroundColor: "#4A8EC0", color: "#fff",
                  padding: "14px 20px", fontWeight: "bold", fontSize: 20,
                  display: "flex", alignItems: "center", justifyContent: "space-between"
                }}>
                  <span>Bize mesaj bırakın</span>
                  <svg onClick={this.closeContactPanel} style={{ cursor: "pointer", color: "#fff" }}
                    xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                    viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
                  </svg>
                </div>
                <div style={{ padding: 24, overflowY: "auto", flex: 1 }}>
                  <div style={{ marginBottom: 18 }}>
                    <label style={{ display: "block", marginBottom: 8, fontWeight: 600, fontSize: 16, color: "#222" }}>
                      Adınız <span style={{ color: "#888", fontWeight: 400 }}>(isteğe bağlı)</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.contactName}
                      onChange={(e) => this.setState({ contactName: e.target.value })}
                      placeholder="Adınızı girin"
                      style={{ borderRadius: 6, border: "1px solid #d0d7de", padding: "10px 12px", fontSize: 15, minHeight: 44 }}
                    />
                  </div>
                  <div style={{ marginBottom: 18 }}>
                    <label style={{ display: "block", marginBottom: 8, fontWeight: 600, fontSize: 16, color: "#222" }}>
                      E-posta adresi
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      value={this.state.contactEmail}
                      onChange={(e) => this.setState({ contactEmail: e.target.value })}
                      placeholder="E-posta adresinizi girin"
                      style={{ borderRadius: 6, border: "1px solid #d0d7de", padding: "10px 12px", fontSize: 15, minHeight: 44 }}
                    />
                  </div>
                  <div style={{ marginBottom: 18 }}>
                    <label style={{ display: "block", marginBottom: 8, fontWeight: 600, fontSize: 16, color: "#222" }}>
                      Size nasıl yardımcı olabiliriz?
                    </label>
                    <textarea
                      className="form-control"
                      rows={10}
                      value={this.state.contactMessage}
                      onChange={(e) => this.setState({ contactMessage: e.target.value })}
                      placeholder="Mesajınızı buraya yazın..."
                      style={{ borderRadius: 6, border: "1px solid #d0d7de", padding: "10px 12px", fontSize: 15, resize: "vertical", minHeight: 140 }}
                    />
                  </div>
                  <div style={{ marginBottom: 20 }}>
                    <label style={{ display: "block", marginBottom: 8, fontWeight: 600, fontSize: 16, color: "#222" }}>
                      Ekler
                    </label>
                    <div style={{
                      border: "2px dashed #c8d0d8", borderRadius: 8, padding: 22,
                      textAlign: "center", backgroundColor: "#fafbfc", cursor: "pointer",
                      transition: "all 0.2s ease"
                    }}
                      onClick={() => this.fileInput && this.fileInput.click()}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const dt = e.dataTransfer;
                        if (dt && dt.files) {
                          const all = Array.from(dt.files);
                          const images = all.filter((f) => f && f.type && f.type.startsWith("image/"));
                          if (all.length !== images.length) {
                            toastr.warning("Uyarı", "Sadece resim dosyaları eklenebilir.");
                          }
                          if (images.length > 5) {
                            toastr.warning("Uyarı", "En fazla 5 resim ekleyebilirsiniz.");
                            this.setState({ contactFiles: images.slice(0, 5) });
                          } else {
                            this.setState({ contactFiles: images });
                          }
                        }
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6b7684" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: 8 }}>
                        <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                      </svg>
                      <div style={{ color: "#57606a", fontSize: 15 }}>
                        En fazla 5 resim ekleyin
                      </div>
                      <input
                        ref={(el) => { this.fileInput = el; }}
                        type="file"
                        accept="image/*"
                        multiple
                        style={{ display: "none" }}
                        onChange={this.handleContactFileChange}
                      />
                    </div>
                    {this.state.contactFiles.length > 0 && (
                      <div style={{ marginTop: 12 }}>
                        {this.state.contactFiles.map((file, idx) => (
                          <div key={idx} style={{
                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            padding: "8px 12px", border: "1px solid #eaeef2", borderRadius: 6,
                            marginBottom: 6, backgroundColor: "#f6f8fa"
                          }}>
                            <div style={{ display: "flex", alignItems: "center", minWidth: 0, flex: 1 }}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4a87bf" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 8, flexShrink: 0 }}>
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                <polyline points="14 2 14 8 20 8"></polyline>
                              </svg>
                              <span style={{ fontSize: 14, color: "#24292f", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.name}</span>
                              <span style={{ fontSize: 12, color: "#6b7684", marginLeft: 8, flexShrink: 0 }}>
                                {file.size < 1024 ? file.size + " B" : file.size < 1048576 ? (file.size / 1024).toFixed(1) + " KB" : (file.size / 1048576).toFixed(1) + " MB"}
                              </span>
                            </div>
                            <button
                              type="button"
                              onClick={(e) => { e.stopPropagation(); this.removeContactFile(idx); }}
                              style={{
                                border: "none", background: "transparent", cursor: "pointer",
                                color: "#cf222e", padding: 4, marginLeft: 8, flexShrink: 0
                              }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                              </svg>
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <EkoFormButton
                      className={"btn btn-primary"}
                      style={{
                        backgroundColor: "#2c353f", borderColor: "#2c353f",
                        color: "#fff", padding: "10px 28px", fontSize: 16,
                        fontWeight: 600, borderRadius: 6, minHeight: 44, minWidth: 120
                      }}
                      isLoading={this.state.contactSubmitting}
                      onClick={this.submitContactForm}
                      label={"Gönder"}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          <Footer />
        </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    addDocument: state.page.addDocument
  };
}

export default connect(mapStateToProps, actions)(withRouter(Dashboard));
